import React from "react";
import { IImage } from "types";
import { GallerySlide, SlideProps } from "components";

interface ImageSlideProps extends IImage, SlideProps {}

export const ImageSlide: React.FC<ImageSlideProps> = ({
  image,
  preview,
  ...rest
}) => {
  const media = (
    <div className="gallery-slide__media">
      {preview && (
        <div
          className="gallery-slide__preview"
          style={{ backgroundImage: `url(${preview})` }}
        />
      )}
      <div
        className="gallery-slide__image lozad"
        data-background-image={image}
      />
    </div>
  );

  return <GallerySlide media={media} {...rest} />;
};
